import React from "react";
import { Navigate, Outlet } from "react-router";
import type { IUser } from "../types/iuser";

interface AdminRouteProps {
  currentUser: IUser;
}

const AdminRouteGuard = ({ currentUser }: AdminRouteProps) => {
  if (!currentUser.admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRouteGuard;
